import {View} from 'react-native';
import React from 'react';
import {useNavigation} from '@react-navigation/native';
import {Link} from '../../../../../../shared/components/link';
import {Screens} from '../../../../../../shared/routing';
import {dateFormats} from '../../../../../../shared/constants/date';
import {datePipe} from '../../../../../../shared/pipes/date';
import {ViewProps} from './model';
import {Text} from '../../../../../../shared/components/text';
import {images} from '../../../../../../assets/icons';
import {GetMobileStyles} from './styles';

export default ({requests}: ViewProps) => {
  const nav = useNavigation();
  const styles = GetMobileStyles();
  return (
    <View style={styles.container}>
      {requests.map((request, index) => {
        const isRead = request.isRead;
        const Icon = request.isRead ? images.NotCheckRound : images.CheckRound;
        const rowNumber = index + 1;
        return (
          <Link
            testID={`request-row-${rowNumber}`}
            key={request.id}
            navigate={nav.navigate}
            screenParams={{id: request.id || ''}}
            screen={Screens.SupportServiceTopic}>
            <View style={[styles.item]}>
              <View style={[styles.itemContent]}>
                <View style={[styles.requestId]}>
                  <Text testID={`request-${request.id}-id`} style={isRead ? styles.itemText : styles.itemTextNotRead}>
                    {request.id}
                  </Text>
                </View>
                <View style={[styles.icon]}>
                  <Icon width={styles.icon.width} height={styles.icon.height} color={styles.icon.color} />
                </View>
                <View style={[styles.itemTextWrapper]}>
                  <Text
                    testID={`request-topic-${rowNumber}-id`}
                    style={isRead ? styles.itemText : styles.itemTextNotRead}>
                    {request.topic}
                  </Text>
                </View>
              </View>
              <View style={[styles.itemDateTimeWrapper]}>
                <Text testID={`request-datetime-${rowNumber}-id`} style={styles.itemDateTime} numberOfLines={1}>
                  {datePipe(request.dateTime, dateFormats.fullDateWithTime)}
                </Text>
              </View>
            </View>
          </Link>
        );
      })}
    </View>
  );
};
